import type { CardBrand } from '@/components/billing/billing.interface'

const VALID_CARD_BRANDS: CardBrand[] = ['visa', 'mastercard', 'amex', 'discover']

export const toCardBrand = (brand: string | null | undefined): CardBrand => {
  if (!brand) return 'visa'
  const normalized = brand.toLowerCase()
  if (VALID_CARD_BRANDS.includes(normalized as CardBrand)) {
    return normalized as CardBrand
  }
  return 'visa'
}
